'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isElementId = exports.checkIdValid = exports.getClientTick = exports.getClientId = exports.getTimestamp = undefined;

var _base = require('base62');

var _base2 = _interopRequireDefault(_base);

var _uidConstants = require('./uidConstants');

var _timestamp = require('./timestamp');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTimestamp = exports.getTimestamp = function getTimestamp(id) {
    return (0, _timestamp.parseTimestamp)(id.slice(0, _uidConstants.TIMESTAMP_LENGTH));
};
var getClientId = exports.getClientId = function getClientId(id) {
    return id.slice(_uidConstants.TIMESTAMP_LENGTH, _uidConstants.TIMESTAMP_LENGTH + _uidConstants.CLIENT_ID_LENGTH);
};
var getClientTick = exports.getClientTick = function getClientTick(id) {
    return _base2.default.decode(id.slice(_uidConstants.TIMESTAMP_LENGTH + _uidConstants.CLIENT_ID_LENGTH));
};

var checkIdValid = exports.checkIdValid = function checkIdValid(id, clientId, lastTick) {
    if (id.length !== _uidConstants.ELEMENT_ID_LENGTH) return false;
    if (getClientId(id) !== clientId) return false;
    if (getClientTick(id) <= lastTick) return false;
    return true;
};

var isElementId = exports.isElementId = function isElementId(id) {
    if (id.length !== _uidConstants.ELEMENT_ID_LENGTH) return false;
    return true;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/uid/idValidator.js
// module id = 799
// module chunks = 0